module.exports = __webpack_public_path__ + "static/media/i_v student1.be223f00.svg";